import React from 'react';
import PropTypes from 'prop-types';
import { InputErrorMessage } from 'shared/components';
import './styles.scss';

const Checkbox = ({
  disabled,
  error,
  inputId,
  value,
  label,
  handleChange,
  featureEnabled,
  featureAvailable,
  notAvailableMessage,
  ...rest
}) => {
  const handleInputChange = (e) => handleChange(e.target.checked);

  return (
    <div className="Checkbox">
      <label htmlFor={inputId}>
        <input
          tabIndex={0}
          type="checkbox"
          className={error ? 'has-error' : ''}
          id={inputId}
          checked={value}
          disabled={disabled}
          onChange={(e) => handleInputChange(e)}
          {...rest}
        />
        {label}
      </label>
      {featureAvailable && !featureEnabled && (
        <InputErrorMessage text={notAvailableMessage} />
      )}
      <InputErrorMessage text={error} />
    </div>
  );
};

Checkbox.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.string,
  value: PropTypes.bool,
  label: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  featureEnabled: PropTypes.bool,
  featureAvailable: PropTypes.bool,
  notAvailableMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

Checkbox.defaultProps = {
  disabled: false,
  error: '',
  value: false,
  label: '',
  handleChange: () => {},
  featureEnabled: true,
  featureAvailable: true,
  notAvailableMessage: '',
};

export default Checkbox;
